/**
 * Till Payments Checkout Redirect
 * Intercepts Shopify checkout and redirects to Till Payments
 */

(function() {
  'use strict';

  console.log('[Till Checkout] Script loaded');

  /**
   * Get cart data
   */
  function getCartData() {
    return fetch('/cart.json', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(function(res) { return res.json(); })
    .catch(function(err) {
      console.error('[Till Checkout] Error fetching cart:', err);
      return null;
    });
  }

  /**
   * Redirect to Till Payments page with cart info
   */
  function redirectToTillCheckout(cartData) {
    if (!cartData) {
      console.error('[Till Checkout] No cart data');
      return false;
    }

    // Redirect to cart payment page with cart parameters
    var tillUrl = '/pages/cart-checkout-payment?amount=' + 
      encodeURIComponent(cartData.total_price) +
      '&currency=' + encodeURIComponent(cartData.currency) +
      '&items=' + encodeURIComponent(cartData.item_count);

    console.log('[Till Checkout] Redirecting to Till payment:', tillUrl);
    window.location.href = tillUrl;
    return true;
  }

  /**
   * Intercept cart form submission
   */
  function initFormInterception() {
    var cartForm = document.getElementById('cart');
    
    if (!cartForm) {
      console.log('[Till Checkout] Cart form not found');
      return;
    }

    // Store original submit handler
    var originalSubmit = cartForm.onsubmit;

    cartForm.onsubmit = function(e) {
      var checkoutBtn = document.getElementById('checkout');
      
      // Only intercept if checkout button was clicked
      if (checkoutBtn && e.submitter === checkoutBtn) {
        console.log('[Till Checkout] Checkout button intercepted');
        e.preventDefault();
        e.stopPropagation();

        getCartData().then(function(cartData) {
          if (cartData && cartData.items.length > 0) {
            redirectToTillCheckout(cartData);
          } else {
            console.warn('[Till Checkout] Empty cart, submitting normally');
            if (originalSubmit) originalSubmit.call(cartForm, e);
          }
        });

        return false;
      }

      // Let other form submissions through (like update quantities)
      return true;
    };

    console.log('[Till Checkout] Form submission interceptor attached');
  }

  /**
   * Listen for checkout button clicks as backup
   */
  function initButtonClickInterception() {
    document.addEventListener('click', function(e) {
      var checkoutBtn = document.getElementById('checkout');

      if (e.target === checkoutBtn) {
        console.log('[Till Checkout] Checkout button clicked directly');
        e.preventDefault();
        e.stopPropagation();

        getCartData().then(function(cartData) {
          if (cartData && cartData.items.length > 0) {
            redirectToTillCheckout(cartData);
          }
        });
      }
    }, true);
  }

  /**
   * Initialize on page load
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initFormInterception();
        initButtonClickInterception();
      });
    } else {
      initFormInterception();
      initButtonClickInterception();
    }
  }

  init();
})();
